import React from "react";
import "../styles/loading.css";

export default function LoadingError({ message, onRetry, onDismiss }) {
  return (
    <div className="gl-error-card" role="alert">
      <div className="flex items-start gap-3">
        <span className="material-symbols-outlined text-red-500 text-[22px]">error</span>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm mb-0.5">Loading failed</div>
          <div className="text-sm text-gray-600 dark:text-gray-300 mb-3">{message}</div>
          <div className="flex gap-2">
            {onRetry && (
              <button type="button" className="erp-btn-primary text-xs px-3 py-1.5" onClick={onRetry}>
                Retry
              </button>
            )}
            {onDismiss && (
              <button
                type="button"
                className="rounded-lg border border-outline-variant/60 px-3 py-1.5 text-xs font-medium"
                onClick={onDismiss}
              >
                Dismiss
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
